<app-page-live-chat [modalMode]="true" [bsModalRef]="bsModalRef" [chatId]="chatId" style="height: 100%;"></app-page-live-chat>
